/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import { RECEIVED_CUSTOM_VIDEO } from 'state/customVideo/CustomVideoActions';
import { RECEIVED_VIDEO_ELIGIBILITIES } from 'state/Actions';

export const customVideoInitialState = {
  base64RequestString: '',
  clipID: '',
  errorCode: -1,
  touchPoint: {},
  vendorID: '',
  externalUberId: null
};

export const customVideoReducer = (state = customVideoInitialState, action) => {
  if (action.type === RECEIVED_CUSTOM_VIDEO) {
    return {
      ...action.customVideo
    };
  }
  return state;
};

export const customVideoEligibilityReducer = (state, action) => {
  if (action.type === RECEIVED_VIDEO_ELIGIBILITIES) {
    return action.videoeligibilities;
  }

  return state;
};
